import React from 'react';

type Variant = 'service' | 'editorial' | 'pricing' | 'testimonial' | 'feature';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  variant?: Variant;
  children: React.ReactNode;
};

const base = 'block transition duration-300';

const variants: Record<Variant, string> = {
  // Standard service / list card. Subtle sage shadow, lifts on hover.
  service:
    'bg-white rounded-2xl p-6 md:p-7 shadow-sage hover:shadow-sage-lg hover:-translate-y-1 ' +
    'ring-1 ring-brand-sage/10',

  // No-chrome editorial. Used for testimonials, pull-quotes, prose blocks.
  editorial:
    'bg-transparent p-6 md:p-7',

  // Premium pricing tier — gold hairline, no shadow until hover.
  pricing:
    'bg-cream-50 rounded-2xl p-8 md:p-10 ring-1 ring-brand-gold/40 ' +
    'hover:shadow-gold transition',

  // Testimonial — quiet, with bottom hairline rule for rhythm.
  testimonial:
    'bg-transparent p-5 md:p-6 border-b border-brand-sage/30 last:border-b-0',

  // Feature card with icon — softer than service.
  feature:
    'bg-cream-50/95 rounded-2xl p-6 md:p-8 ring-1 ring-brand-sage/15 ' +
    'hover:ring-brand-sage/40 hover:-translate-y-1 hover:shadow-sage',
};

export function Card({ variant = 'service', className = '', children, ...rest }: Props) {
  return (
    <div className={`${base} ${variants[variant]} ${className}`} {...rest}>
      {children}
    </div>
  );
}
